import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-app-reset-dialog',
  templateUrl: './confirm-app-reset-dialog.component.html',
  styleUrls: ['./confirm-app-reset-dialog.component.scss']
})
export class ConfirmAppResetDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
